import { useStoreActions, useStoreState } from "easy-peasy";
import { useCallback, useEffect } from "react";
import { getCurrentAuth } from "../../hooks/useAxiosPrivate";
import { useLocation } from "react-router-dom";
import { ReduxStoreI } from "../../store/redux-store";
import useConfig from "../../hooks/useConfig";
// Import the hook with the correct path

const BlockingWrapper = ({ children }: { children: React.ReactNode }) => {
  const auth = getCurrentAuth();
  const configData = useConfig();
  const { getAllRules, detectLocation } = useStoreActions(
    (action: ReduxStoreI) => action.rules
  );
  const hasGeoLocation = ["usah", "dev"].includes(configData.name);
  useEffect(() => {
    if (auth.AccessToken && hasGeoLocation) {
      detectLocation();
    }
  }, [detectLocation, auth.AccessToken, hasGeoLocation]);
  const GetAllRules = useCallback(async () => {
    getAllRules();
  }, [getAllRules]);

  useEffect(() => {
    if (auth.AccessToken && hasGeoLocation) {
      GetAllRules();
    }
  }, [GetAllRules, auth.AccessToken, hasGeoLocation]);

  // Use our MaxMind GeoIP country detection hook
  // const { locationData, isUsingVpnOrProxy } = useDetectUserCountry();

  return <>{children}</>;
};

export default BlockingWrapper;
